// store/diagramViewerSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DiagramDataType, DiagramViewerState } from './diagramViewerInterface';

const initialState: DiagramViewerState = {
  isOpen: false,
  diagramData: null,
  refreshTaxonomy: false,
};

const diagramViewerSlice = createSlice({
  name: 'diagramViewer',
  initialState,
  reducers: {
    openDiagram: (state, action: PayloadAction<DiagramDataType>) => {
      state.isOpen = true;
      state.diagramData = action.payload;
    },
    closeDiagram: (state) => {
      state.isOpen = false;
    },
    updateDiagramData: (state, action: PayloadAction<Partial<DiagramDataType>>) => {
      if (!state.diagramData) {
        // When there is no existing diagram data (e.g. deep link entry),
        // initialize the slice from the incoming payload instead of
        // attempting to shallow-spread a null value.
        state.diagramData = { ...action.payload } as DiagramDataType;
      } else {
        state.diagramData = { ...state.diagramData, ...action.payload };
      }
    },
    updateDiagramData1: (
      state,
      action: PayloadAction<{
        [key: string]: Partial<{ name: string; description: string; aiEnablers?: string[] }>;
      }>
    ) => {
      if (state.diagramData?.DiagramData?.diagram?.data) {
        state.diagramData.DiagramData.diagram.data = {
          ...state.diagramData.DiagramData.diagram.data,
          ...action.payload,
        } as { [key: string]: { name: string; description: string } };
      }
    },
    resetDiagramData: (state) => {
      state.diagramData = null;
    },
    refreshTaxonomy: (state, action: PayloadAction<boolean>) => {
      state.refreshTaxonomy = action.payload;
    },
    setDiagramEditPermission: (state, action) => {
      if (!state.diagramData) state.diagramData = {};
      state.diagramData.isEditPermission = action.payload;
    },
  },
});

export const {
  openDiagram,
  closeDiagram,
  updateDiagramData,
  resetDiagramData,
  refreshTaxonomy,
  setDiagramEditPermission,
  updateDiagramData1,
} = diagramViewerSlice.actions;

export default diagramViewerSlice.reducer;
